import React from 'react';
import { cn } from '@/lib/utils';
import './styles/button.css';

const variantClasses = {
  default: 'btn-primary',
  destructive: 'btn-destructive',
  outline: 'btn-outline',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  link: 'btn-link',
} as const;

const sizeClasses = {
  default: '', // btn-md is included in variant classes
  sm: 'btn-sm',
  lg: 'btn-lg',
  icon: 'btn-icon',
} as const;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variantClasses;
  size?: keyof typeof sizeClasses;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  type = 'button',
  variant = 'default',
  size = 'default',
  children,
  className,
  ...props
}) => (
  <button
    type={type}
    className={cn(variantClasses[variant], sizeClasses[size], className)}
    {...props}
  >
    {children}
  </button>
);
